import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcFilter(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 15.25c1.259 0 2.317.846 2.644 2H20.5a.75.75 0 0 1 0 1.5h-2.856a2.749 2.749 0 0 1-5.288 0H3.5a.75.75 0 0 1 0-1.5h8.856a2.75 2.75 0 0 1 2.644-2m0 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m-7-7.5c1.258 0 2.317.846 2.644 2H20.5a.75.75 0 0 1 0 1.5h-9.856a2.749 2.749 0 0 1-5.288 0H3.5a.75.75 0 0 1 0-1.5h1.856A2.75 2.75 0 0 1 8 9.25m0 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5m7-7.5c1.259 0 2.317.846 2.644 2H20.5a.75.75 0 0 1 0 1.5h-2.856a2.749 2.749 0 0 1-5.288 0H3.5a.75.75 0 0 1 0-1.5h8.856a2.75 2.75 0 0 1 2.644-2m0 1.5a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5"
  }));
}
var IcFilter = createNolIcon(/*#__PURE__*/forwardRef(SvgIcFilter));

export { IcFilter as I };
